import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Diagnostic } from "@codemirror/lint";

export type CodeEditorReservedWordsSection = "snowSQLReservedWords";

@Injectable({
  providedIn: "root",
})
export class CodeEditorService {
  // subject to add content to editor wherever its current focus is at
  public addContent$ = new Subject();
  public snowSQLReservedWords = [
    {
      label: "ACCOUNT",
      type: "keyword",
    },
    {
      label: "ALL",
      type: "keyword",
    },
    {
      label: "ALTER",
      type: "keyword",
    },
    {
      label: "AND",
      type: "keyword",
    },
    {
      label: "ANY",
      type: "keyword",
    },
    {
      label: "AS",
      type: "keyword",
    },
    {
      label: "BETWEEN",
      type: "keyword",
    },
    {
      label: "BY",
      type: "keyword",
    },
    {
      label: "CASE",
      type: "keyword",
    },
    {
      label: "CAST",
      type: "keyword",
    },
    {
      label: "CHECK",
      type: "keyword",
    },
    {
      label: "COLUMN",
      type: "keyword",
    },
    {
      label: "CONNECT",
      type: "keyword",
    },
    {
      label: "CONNECTION",
      type: "keyword",
    },
    {
      label: "CONSTRAINT",
      type: "keyword",
    },
    {
      label: "CREATE",
      type: "keyword",
    },
    {
      label: "CROSS",
      type: "keyword",
    },
    {
      label: "CURRENT",
      type: "keyword",
    },
    {
      label: "CURRENT_DATE",
      type: "keyword",
    },
    {
      label: "CURRENT_TIME",
      type: "keyword",
    },
    {
      label: "CURRENT_TIMESTAMP",
      type: "keyword",
    },
    {
      label: "CURRENT_USER",
      type: "keyword",
    },
    {
      label: "DATABASE",
      type: "keyword",
    },
    {
      label: "DELETE",
      type: "keyword",
    },
    {
      label: "DISTINCT",
      type: "keyword",
    },
    {
      label: "DROP",
      type: "keyword",
    },
    {
      label: "ELSE",
      type: "keyword",
    },
    {
      label: "EXISTS",
      type: "keyword",
    },
    {
      label: "FALSE",
      type: "keyword",
    },
    {
      label: "FOLLOWING",
      type: "keyword",
    },
    {
      label: "FOR",
      type: "keyword",
    },
    {
      label: "FROM",
      type: "keyword",
    },
    {
      label: "FULL",
      type: "keyword",
    },
    {
      label: "GRANT",
      type: "keyword",
    },
    {
      label: "GROUP",
      type: "keyword",
    },
    {
      label: "GSCLUSTER",
      type: "keyword",
    },
    {
      label: "HAVING",
      type: "keyword",
    },
    {
      label: "ILIKE",
      type: "keyword",
    },
    {
      label: "IN",
      type: "keyword",
    },
    {
      label: "INCREMENT",
      type: "keyword",
    },
    {
      label: "INNER",
      type: "keyword",
    },
    {
      label: "INSERT",
      type: "keyword",
    },
    {
      label: "INTERSECT",
      type: "keyword",
    },
    {
      label: "INTO",
      type: "keyword",
    },
    {
      label: "IS",
      type: "keyword",
    },
    {
      label: "ISSUE",
      type: "keyword",
    },
    {
      label: "JOIN",
      type: "keyword",
    },
    {
      label: "LATERAL",
      type: "keyword",
    },
    {
      label: "LEFT",
      type: "keyword",
    },
    {
      label: "LIKE",
      type: "keyword",
    },
    {
      label: "LOCALTIME",
      type: "keyword",
    },
    {
      label: "LOCALTIMESTAMP",
      type: "keyword",
    },
    {
      label: "MINUS",
      type: "keyword",
    },
    {
      label: "NATURAL",
      type: "keyword",
    },
    {
      label: "NOT",
      type: "keyword",
    },
    {
      label: "NULL",
      type: "keyword",
    },
    {
      label: "OF",
      type: "keyword",
    },
    {
      label: "ON",
      type: "keyword",
    },
    {
      label: "OR",
      type: "keyword",
    },
    {
      label: "ORDER",
      type: "keyword",
    },
    {
      label: "ORGANIZATION",
      type: "keyword",
    },
    {
      label: "QUALIFY",
      type: "keyword",
    },
    {
      label: "REGEXP",
      type: "keyword",
    },
    {
      label: "REVOKE",
      type: "keyword",
    },
    {
      label: "RIGHT",
      type: "keyword",
    },
    {
      label: "RLIKE",
      type: "keyword",
    },
    {
      label: "ROW",
      type: "keyword",
    },
    {
      label: "ROWS",
      type: "keyword",
    },
    {
      label: "SAMPLE",
      type: "keyword",
    },
    {
      label: "SCHEMA",
      type: "keyword",
    },
    {
      label: "SELECT",
      type: "keyword",
    },
    {
      label: "SET",
      type: "keyword",
    },
    {
      label: "SOME",
      type: "keyword",
    },
    {
      label: "START",
      type: "keyword",
    },
    {
      label: "TABLE",
      type: "keyword",
    },
    {
      label: "TABLESAMPLE",
      type: "keyword",
    },
    {
      label: "THEN",
      type: "keyword",
    },
    {
      label: "TO",
      type: "keyword",
    },
    {
      label: "TRIGGER",
      type: "keyword",
    },
    {
      label: "TRUE",
      type: "keyword",
    },
    {
      label: "TRY_CAST",
      type: "keyword",
    },
    {
      label: "UNION",
      type: "keyword",
    },
    {
      label: "UNIQUE",
      type: "keyword",
    },
    {
      label: "UPDATE",
      type: "keyword",
    },
    {
      label: "USING",
      type: "keyword",
    },
    {
      label: "VALUES",
      type: "keyword",
    },
    {
      label: "VIEW",
      type: "keyword",
    },
    {
      label: "WHEN",
      type: "keyword",
    },
    {
      label: "WHENEVER",
      type: "keyword",
    },
    {
      label: "WHERE",
      type: "keyword",
    },
    {
      label: "WITH",
      type: "keyword",
    },
  ];

  constructor() {}

  getReservedWords(
    customOptions: { label: string; type: string }[] = [],
    section: CodeEditorReservedWordsSection
  ) {
    return this?.[section]?.length
      ? [...this[section], ...customOptions]
      : [...customOptions];
  }

  formatSnowflakeErrors(
    error: string,
    attemptedQuery: string, //partial query used
    fullQuery?: string // full query to compare against to find actual line and position
  ): Diagnostic[] {
    // const fullQuery = this.form.value.worksheet;
    // const attemptedQuery = this.selectedTab?.data?.attemptedQuery;
    if (!attemptedQuery) return [];

    if(!fullQuery)fullQuery = attemptedQuery;

    const diagnostics: Diagnostic[] = [];

    // find the starting index of the attemptedQuery within the fullQuery
    const startIndex = fullQuery.indexOf(attemptedQuery);
    if (startIndex === -1) return []; // if not found, return empty diagnostics

    // updated regex to match the new error format
    let regex = /line (\d+) at position (\d+)\s+(?:unexpected|invalid identifier) ['"]([^'"]+)['"]/;
    
    const match = error.match(regex);
    if (match?.[1] && match?.[2] && match?.[3]) {
      const lineNumber = parseInt(match[1], 10);
      const position = parseInt(match[2], 10);
      const invalidIdentifier = match[3];

      // Calculate the actual line and position in the fullQuery
      const linesBeforeAttemptedQuery = fullQuery
        .substring(0, startIndex)
        .split("\n");
      const actualLineNumber =
        linesBeforeAttemptedQuery.length + lineNumber - 1;

      const sqlLines = fullQuery.split("\n");
      let currentIndex = 0;
      for (let i = 0; i < actualLineNumber - 1; i++) {
        currentIndex += sqlLines[i].length + 1;
      }

      const from = currentIndex + position;
      const to = from + invalidIdentifier.length;
      const message = `SQL compilation error: error line ${actualLineNumber} at position ${position}\ninvalid identifier '${invalidIdentifier}'`;

      diagnostics.push({
        from: from,
        to: to,
        severity: "error",
        message: message,
        source: "Snowflake",
      });
    } else {
      regex = /'([^']*)'|"([^"]*)"/;
      let match = error.match(regex);
      const errorText = match?.[1];
      const sqlText = fullQuery.toLowerCase();
      const index = sqlText.indexOf(errorText?.toLowerCase());
      if (index < 0) return [];
      const from = index;
      const to = from + errorText.length;

      diagnostics.push({
        from: from,
        to: to,
        severity: "error",
        message: error,
        source: "Snowflake",
      });
    }

    return diagnostics;
  }
}
